export const QUERY_RATE_CARD = "QUERY_RATE_CARD";
export const QUERY_PAYEE_ENGAGEMENT_RATE_CARD_BY_PAYEE =
  "QUERY_PAYEE_ENGAGEMENT_RATE_CARD_BY_PAYEE";
